import { render, staticRenderFns } from "./v-mod-coupon.vue?vue&type=template&id=da1e2b5e"
import script from "./v-mod-coupon.vue?vue&type=script&lang=js"
export * from "./v-mod-coupon.vue?vue&type=script&lang=js"
import style0 from "./v-mod-coupon.vue?vue&type=style&index=0&id=da1e2b5e&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports